export const isFirefox = () => {
  return (
    typeof navigator !== 'undefined' &&
    /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent)
  );
};
